__webpack_require__.p = "/acquisition-contracts-modal-split-5/referrals-hub/";